import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { WHO_AM_I } from "api/Service";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useHeaderProfile = () => {
  const handleNetworkError = useHandleNetworkError("Error fetching profile");

  const query = useQuery({
    queryKey: ["whoami"],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance(true);
      const response = await axiosInstance.get(WHO_AM_I);
      return response?.data?.staffMember ?? null;
    },
    enabled: !!sessionStorage.getItem("accessToken"),
    staleTime: 1000 * 60 * 5,
    retry: (failureCount, error) => {
      if (error?.response?.status === 403) return false;
      return failureCount < 3;
    },
  });

  useEffect(() => {
    if (query.error) {
      handleNetworkError(query.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.error]);

  return query;
};
